module.exports = __webpack_public_path__ + "d467194fa86d668c4b2b8cae59b32d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/welcome.png
// module id = 1097
// module chunks = 0